import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    orientacion: [],
  },

  getters: {
    getOrientacion: (state) => state.orientacion,
  },

  mutations: {
    SET_ORIENTACION(state, orientacion) {
      state.orientacion = orientacion;
    },
  },

  actions: {
    async fetchOrientacion({ commit }) {
      await axios
        .get('PoliciaCuadrantes/C3/catOrientacion')
        .then((response) => {
          commit('SET_ORIENTACION', response.data.data);
        });
    },
  },
};
